<template>
  <div
    class="landing-container"
    role="main"
    aria-label="One Philly Front Door Landing Page"
  >
    <!-- Header img -->
    <div
      class="image-section"
      role="banner"
    >
      <img
        src="../../public/OPFDH.jpg"
        alt="Welcome to One Philly Front Door Header Image"
        aria-label="Welcome banner for One Philly Front Door website"
      >
    </div>
    <div
      class="content-button-wrapper"
      role="article"
    >
      <div class="text-section">
        <p
          class="welcome-text"
          aria-label="Welcome message"
        >
          <b>{{ $t("message.welcomeMessage") }}</b>
        </p>
        <p
          class="welcome2-text"
          aria-label="Welcome2 message"
        >
          {{ $t("message.welcomeMessage2") }} <a
            href="https://www.phila.gov/programs/home-initiative/"
            target="_blank"
          >H.O.M.E. webpage.</a>
        </p>
        <p
          class="instruction-text"
          aria-label="Instructions"
        >
          <b>{{ $t("message.instructions") }}</b>
        </p>
      </div>
    </div>
    <div class="button-container">
      <button
        class="image-button"
        aria-label="Get Started - Begin your housing assistance journey"
        tabindex="0"
        @click="goToHome"
      >
        <img
          src="../../public/OPFDB.png"
          alt="Get Started Button"
          role="img"
        >
      </button>
    </div>
    <div
      class="content-button-wrapper"
      role="article"
    >
      <div class="text-section">
        <p
          class="welcome3-text"
          aria-label="Welcome3 message"
        >
          {{ $t("message.welcomeMessage3") }}
        </p>
      </div>
    </div>

    <!-- Programs List -->
    <div
      class="content-button-wrapper"
      role="article"
    >
      <div class="text-section">
        <div
          class="apps"
          role="navigation"
          aria-label="Available Housing Programs"
        >
          <hr aria-hidden="true">
          <a
            href="https://phdcphila.org/residents/home-repair/adaptive-modifications-program/"
            class="is-external-link is-small"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Adaptive Modification Program - Opens in new tab"
          >Adaptive Modifications Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://phdcphila.org/residents/home-repair/basic-systems-repair-program/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Basic Systems Repair Program - Opens in new tab"
          >Basic Systems Repair Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://philaenergy.org/programs-initiatives/built-to-last/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Built to Last - Opens in new tab"
          >Built to Last <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://www.phila.gov/programs/curbside-appeal-program/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Curbside Appeal Program - Opens in new tab"
          >Curbside Appeal Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://phdcphila.org/disaster-recovery-and-resilience-program-drrp/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Disaster Recovery & Resilience Program - Opens in new tab"
          >Disaster Recovery & Resilience Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://phdcphila.org/facade-improvement-program/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facade Improvement Program - Opens in new tab"
          >Facade Improvement Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://www.ecasavesenergy.org/heater-hotline"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Heater Hotline - Opens in new tab"
          >Heater Hotline <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://www.phila.gov/documents/homestead-exemption-application/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Homestead Exemption Application - Opens in new tab"
          >Homestead Exemption Application <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://www.phila.gov/departments/division-of-housing-and-community-development/neighborhood-resources/housing-counseling/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Housing Counseling - Opens in new tab"
          >Housing Counseling <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://www.phila.gov/services/payments-assistance-taxes/payment-plans-and-assistance-programs/income-based-programs-for-residents/apply-for-the-longtime-owner-occupants-program-loop/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Longtime Owner Occupants Program- Opens in new tab"
          >Longtime Owner Occupants Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://www.phila.gov/departments/division-of-housing-and-community-development/neighborhood-resources/neighborhood-energy-centers-necs/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Neighborhood Energy Centers - Opens in new tab"
          >Neighborhood Energy Centers <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://phdcphila.org/one-philly-mortgage-program/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="One Philly Mortgage Program - Opens in new tab"
          >One Philly Mortgage Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>
              
          <a
            href="https://solarizephilly.org/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="PEA-Solarize Philly Program - Opens in new tab"
          >PEA-Solarize Philly Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://phdcphila.org/residents/homebuyers-and-renters/philly-first-home/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Philly First Home - Opens in new tab"
          >Philly First Home <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://phdcphila.org/rrr/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Restore Repair Renew Loan Program - Opens in new tab"
          >Restore Repair Renew Loan Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://philalegal.org/services/save-your-home-philly-hotline"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Tangled Title - Opens in new tab"
          >Tangled Title <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://phdcphila.org/residents-and-landlords/homebuyers-and-renters/turn-the-key/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Turn the Key - Opens in new tab"
          >Turn the Key <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://uesfacts.org/our-programs/utility-grant-program/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Utility Grant Program - Opens in new tab"
          >Utility Grant Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://dced.pa.gov/programs/weatherization-assistance-program-wap/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Weatherization Assistance Program - Opens in new tab"
          >Weatherization Assistance Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>

          <a
            href="https://www.phila.gov/programs/wills-program/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Wills Program - Opens in new tab"
          >Wills Program <i
            class="fa fa-external-link"
            aria-hidden="true"
          /></a>
        </div>
      </div>
    </div>

    <!-- Logo Section -->
    <div
      class="logos-container"
      role="complementary"
      aria-label="Partner Organizations"
    >
      <div class="home-logo-row">
        <a
          href="https://www.phila.gov/programs/home-initiative/"
          target="_blank"
          class="logo-link"
          aria-label="Visit Philadelphia H.O.M.E Initiative website in new tab"
        >
          <img
            src="../../public/H.O.M.E._Logo_MayorParker_FINAL.jpg"
            alt="Philadelphia H.O.M.E Initiative Logo"
            role="img"
          >
        </a>
      </div>
      <div class="logos-grid">
        <a
          href="https://phdcphila.org"
          target="_blank"
          class="logo-link"
          aria-label="Visit Philadelphia Housing Development Corporation website in new tab"
        >
          <img
            src="../../public/PHDC202412.png"
            alt="Philadelphia Housing Development Corporation Logo"
            role="img"
          >
        </a>
        <a
          href="https://phlcouncil.com"
          target="_blank"
          class="logo-link"
          aria-label="Visit Philadelphia City Council website in new tab"
        >
          <img
            src="../../public/CityCouncil.jpg"
            alt="Philadelphia City Council Logo"
            role="img"
          >
        </a>
        <a
          href="https://philaenergy.org/"
          target="_blank"
          class="logo-link"
          aria-label="Visit Philadelphia Energy Authority website in new tab"
        >
          <img
            src="../../public/PEA_logo.png"
            alt="Philadelphia Energy Authority Logo"
            role="img"
          >
        </a>
        <!-- <a 
          href="https://www.phila.gov/departments/department-of-planning-and-development" 
          target="_blank" 
          class="logo-link"
          aria-label="Visit Department of Planning and Development website in new tab"
        >
          <img 
            src="../../public/DPD_belllogo.png" 
            alt="Department of Planning and Development Logo"
            role="img"
          >
        </a> -->
        <!-- <a
          href="https://www.pcacares.org"
          target="_blank"
          class="logo-link"
          aria-label="Visit Philadelphia Corporation for Aging website in new tab"
        >
          <img
            src="../../public/PCA.png"
            alt="Philadelphia Corporation for Aging Logo"
            role="img"
          >
        </a> -->
        <!-- <a
          href="https://acrobat.adobe.com/id/urn:aaid:sc:VA6C2:bc3ebcbc-e4ac-4d05-84cd-22c477eac2b8/"
          target="_blank"
          class="logo-link"
          aria-label="Visit One Philly Mortgage website in new tab"
        >
          <img
            src="../../public/opm.png"
            alt="One Philly Mortgage Logo"
            role="img"
          >
        </a> -->
        <!-- <a
          href="https://acrobat.adobe.com/id/urn:aaid:sc:VA6C2:bc3ebcbc-e4ac-4d05-84cd-22c477eac2b8/"
          target="_blank"
          class="logo-link"
          aria-label="Visit One Philly Mortgage website in new tab"
        >
          <img
            src="../../public/opm.png"
            alt="One Philly Mortgage Logo"
            role="img"
          >
        </a> -->
      </div>
      <div class="logos-row-3">
        <a
          href="https://www.phila.gov/departments/division-of-housing-and-community-development"
          target="_blank"
          class="logo-link"
          aria-label="Visit Division of Housing and Community Development website in new tab"
        >
          <img
            src="../../public/NewHousingImg.jpg"
            alt="Division of Housing and Community Development Logo"
            role="img"
          >
        </a>
        <a
          href="https://ecasavesenergy.org"
          target="_blank"
          class="logo-link"
          aria-label="Visit Energy Coordinating Agency website in new tab"
        >
          <img
            src="../../public/ECA.jpg"
            alt="Energy Coordinating Agency Logo"
            role="img"
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Landing",
  methods: {
    goToHome() {
      this.$router.push("/Home");
    },
  },
};
</script>

<style scoped>
/* Button and Link Focus States */

.housing-logo {
  width: 200px;
  height: 100px;
  object-fit: contain;
  padding: 10px;
}
.image-button:focus {
  outline: 3px solid #0f4d90; /* City of Philadelphia blue */
  outline-offset: 2px;
  border-radius: 4px;
}

.image-button:focus:not(:focus-visible) {
  outline: none;
}

.image-button:focus-visible {
  outline: 3px solid #0f4d90;
  outline-offset: 2px;
  border-radius: 4px;
}

/* Translation Dropdown Focus States */
.select-language:focus,
.select-language:focus-visible {
  outline: 3px solid #0f4d90;
  outline-offset: 2px;
  border-radius: 4px;
  box-shadow: 0 0 0 3px rgba(15, 77, 144, 0.2);
}

.select-language:focus:not(:focus-visible) {
  outline: none;
}

/* Ensure dropdown remains visible when focused */
.select-language:focus {
  z-index: 100;
  position: relative;
}

/* High contrast mode support */
@media (forced-colors: active) {
  .image-button:focus,
  .select-language:focus {
    outline: 3px solid CanvasText;
  }
}
.content-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}
.landing-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  overflow-x: hidden;
}

.image-section {
  width: 100%;
  position: relative;
  margin-top: 20px;
}

.image-section img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  max-width: 100%;
}

.text-section {
  padding: 1rem;
  max-width: 800px;
  width: 80%;
  flex-wrap: wrap;
  margin-top: 20px;
}

.button-container {
  max-width: 800px;
  width: 80%;
  padding: 0 1rem;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
}

.image-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  margin-left: -1rem;
}

.image-button img {
  max-width: 100%;
  height: auto;
  display: block;
}
.logos-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
  margin-top: 2rem;
}

.home-logo-row {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 2rem;
}

.logos-grid {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 3rem;
  max-width: 1200px;
  width: 90%;
  margin-bottom: 3rem;
}

.logos-row-3 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 3rem;
  width: 100%;
}

.logo-link {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 80px;
  transition: transform 0.2s;
  padding: 10px;
  background-color: white;
  border-radius: 4px;
}

.logo-link:hover {
  transform: scale(1.05);
}

.logo-link img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  object-position: center;
}

.logo-link img[alt="Division of Housing and Community Development Logo"] {
  min-width: 300px;
  min-height: 125%;
  object-fit: contain;
  transform: none;
}

.logo-link img[alt="One Philly Mortgage Logo"] {
  min-width: 350px;
  min-height: 225%;
  object-fit: contain;
  transform: none;
}

.logo-link img[alt="Philadelphia H.O.M.E Initiative Logo"] {
  min-width: 375px;
  min-height: 150%;
  object-fit: contain;
}

.logo-link img[alt="Philadelphia Energy Authority Logo"] {
  min-width: 350px;
  min-height: 175%;
  object-fit: contain;
  padding-left: 19%;
}

/* Ensure consistent logo sizes for mobile */
@media screen and (max-width: 768px) {
  .logo-link img[alt="Division of Housing and Community Development Logo"] {
    width: 200px;
    height: 60px;
  }
  /* .logo-link img[alt="Planning and Developement"] {
    min-width: 200px;
    padding-left: 0;
  } */

  .logo-link img[alt="Philadelphia Energy Authority Logo"] {
    min-width: 300px;
    padding-left: 0;
  }
}

.logo-link:focus {
  outline: 2px solid #0f4d90; /* City of Philadelphia blue */
  outline-offset: 2px;
}

.logo-link:focus:not(:focus-visible) {
  outline: none;
}

.logo-link:focus-visible {
  outline: 2px solid #0f4d90;
  outline-offset: 2px;
}
/* Responsive adjustments */
@media screen and (max-width: 1024px) {
  .logos-grid,
  .logos-row-3 {
    gap: 1.5rem;
  }
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .logo-link img[alt="Division of Housing and Community Development Logo"] {
    width: 200px; /* Mobile size */
  }
  .housing-logo {
    width: 120px;
    height: 60px;
  }
  .text-section,
  .button-container {
    width: 90%;
  }
  .landing-container {
    margin-top: 2.5px;
    margin-top: 60px;
  }

  .content-container {
    width: 90%;
  }
  .logos-grid,
  .logos-row-3 {
    gap: 1rem;
  }

  .logo-link img {
    max-width: 120px;
  }
}

.back-link {
  font-size: 16px;
  color: #0f4d90;
}
.background-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  position: relative;
  margin-top: 80px;
}

.form-container {
  flex: 1;
  margin: 0 5%;
  padding: 20px;
  overflow-y: auto;
  position: relative;
  z-index: 1;
}

.left-img-container,
.right-img-container {
  display: none;
  position: fixed;
  top: 80px;
  height: 100vh;
  width: 20%;
  overflow: hidden;
}
.left-img-container {
  left: 0;
}
.right-img-container {
  right: 0;
}
.apps {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.apps a,
.apps span {
  display: block;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  text-decoration: underline;
  color: #0f4d90; /* match link color */
  cursor: pointer;
}

input[type="radio"] + label {
  color: black;
  margin-left: 5px;
  font-weight: normal;
}

/* Mobile phones (portrait and landscape) */
@media only screen and (max-width: 767px) {
  .form-container {
    margin: 0;
    padding: 10px;
  }

  h1 {
    font-size: 24px;
  }

  h3 {
    font-size: 18px;
  }
}

/* Tablets (portrait and landscape) */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .form-container {
    margin: 0 10%;
  }

  .apps a {
    width: 50%;
  }

  h1 {
    font-size: 28px;
  }

  h3 {
    font-size: 20px;
  }
}

/* Laptops and small desktops */
@media only screen and (min-width: 1024px) and (max-width: 1920px) {
  .left-img-container,
  .right-img-container {
    display: block;
    position: absolute;
    top: 0;
    height: 600px;
    width: 20%;
    overflow: hidden;
    z-index: -1;
  }

  .left-img-container {
    left: 0;
  }

  .right-img-container {
    right: 0;
  }
  .left-img,
.right-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: sticky;
  top: 0;
}

.left-img {
  object-position: center 1%;
}

  .form-container {
    margin: 0 20%;
  }

  .apps a {
    width: 33.33%;
  }
}

/* Large desktops and high-resolution displays */
@media only screen and (min-width: 1440px) {
  .left-img-container,
  .right-img-container {
    width: 25%;
  }

  .form-container {
    margin: 0 25%;
  }

  .apps a {
    width: 25%;
  }
}

/* Shared styles for images */
.left-img,
.right-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.left-img {
  object-position: center 1%;
  padding-right: 40px;
}

/*responsive adjustments */
@media only screen and (max-width: 1023px) {
  .background-container {
    background-color: #f0f0f0;
  }
  .left-img-container,
  .right-img-container {
    display: none;
  }

  .form-container {
    margin: 0 20px;
  }
}

/*form elements are responsive */
input[type="text"],
input[type="number"],
input[type="email"],
select,
textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

/* Base styles for form inputs */
input[type="text"],
input[type="number"],
input[type="email"],
select,
textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: white;
}

/* Media query for screens smaller than 1024x768 */
@media only screen and (max-width: 1023px) {
  .form-container {
    background-color: #f0f0f0; 
  }
  
  .form-container input[type="text"],
  .form-container input[type="number"],
  .form-container input[type="email"],
  .form-container select,
  .form-container textarea {
    background-color: white;
  }
}

/* Media query for 1024x768 and larger screens */
@media only screen and (min-width: 1024px) {
  .left-img-container,
  .right-img-container {
    display: block;
    width: 25%;
  }
  .form-container {
    margin: 0 22%;
  }
  .form-container input[type="text"],
  .form-container input[type="number"],
  .form-container input[type="email"],
  .form-container select,
  .form-container textarea {
    background-color: transparent;
  }
}

/* Styles for 1024px width and larger screens */
@media only screen and (min-width: 1024px) {
  .form-container input[type="text"],
  .form-container input[type="number"],
  .form-container input[type="email"],
  .form-container select,
  .form-container textarea {
    background-color: #f0f0f0;
  }
}

/*radio buttons remain visible */
.radio-fieldset {
  border: none;
  padding: 12px;
  margin: 8px 0;
  outline: none;
  border-radius: 4px;
}

.radio-fieldset:focus-within {
  background-color: rgba(15, 77, 144, 0.05);
  outline: 2px solid #0f4d90;
  outline-offset: 2px;
}

/* Radio button styles */
input[type="radio"] {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  cursor: pointer;
}

/* Remove default focus styles */
input[type="radio"]:focus {
  outline: none;
}

/* Focus and hover states */
.radio-option:focus-within,
.radio-option:hover {
  background-color: rgba(15, 77, 144, 0.05);
}

/* Selected state */
input[type="radio"]:checked + label {
  color: #0f4d90;
  font-weight: normal;
}

/* Ensure form elements are properly spaced */
.cell {
  margin-bottom: 16px;
}

/* Ensure proper focus visibility */
.radio-fieldset:focus {
  outline: 2px solid #0f4d90;
  outline-offset: 2px;
}

/* Extra large screens */
@media only screen and (min-width: 1920px) {
  .left-img-container,
  .right-img-container {
    width: 25%;
    height: 800px;
  }

  .form-container {
    margin: 0 27%;
  }
}

/* Ultra-wide screens */
@media only screen and (min-width: 2560px) {
  .left-img-container,
  .right-img-container {
    width: 30%;
    height: 1000px;
  }

  .form-container {
    margin: 0 32%;
  }
}
</style>
